module.exports = __webpack_public_path__ + "media/images/scoreBet__detailScore__markWrong--dark-d0daeb1ce48254f125950bf96457216e.png";